// extracted by mini-css-extract-plugin
export var block = "QuestionBox-module--block--CUY57";
export var button = "QuestionBox-module--button--2PsnK";
export var questionIcon = "QuestionBox-module--questionIcon--TUtx5";
export var questionText = "QuestionBox-module--questionText--i1Lx0";
export var arrow = "QuestionBox-module--arrow--9fD11";
export var answer = "QuestionBox-module--answer--NYh4P";
export var answerIcon = "QuestionBox-module--answerIcon--CVdDT";
export var answerText = "QuestionBox-module--answerText--zKzym";